import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

// LF360-2026: searching articles and FitFacts to attach to tasks and scenarios.
// Lists go as comma-separated values, which the endpoints read the same as
// repeated ones and which keep a long filter readable in the network tab.
const flat = (query = {}) =>
  Object.fromEntries(
    Object.entries(query).map(([key, value]) => [key, Array.isArray(value) ? value.join(",") : value])
  );

const searchArticles = (query) => axios.get(toQueryString("/api/v1/search/articles?", flat(query)));

const articleFacets = (query) => axios.get(toQueryString("/api/v1/search/articles/facets?", flat(query)));

const articleFilters = () => axios.get("/api/v1/search/articles/filters");

const searchFitFacts = (query) => axios.get(toQueryString("/api/v1/search/fit-facts?", flat(query)));

const fitFactFacets = (query) => axios.get(toQueryString("/api/v1/search/fit-facts/facets?", flat(query)));

const fitFactFilters = () => axios.get("/api/v1/search/fit-facts/filters");

const searchSpotlight = (type, query) =>
  axios.get(toQueryString(`/api/v1/search/spotlight/${type}?`, flat(query)));

const spotlightFacets = (type, query) =>
  axios.get(toQueryString(`/api/v1/search/spotlight/${type}/facets?`, flat(query)));

const searchSubjects = (query) => axios.get(toQueryString("/api/v1/search/subjects?", flat(query)));
const subjectFacets = (query) => axios.get(toQueryString("/api/v1/search/subjects/facets?", flat(query)));

const ApiContentSearch = {
  searchArticles,
  articleFacets,
  articleFilters,
  searchFitFacts,
  fitFactFacets,
  fitFactFilters,
  searchSpotlight,
  spotlightFacets,
  searchSubjects,
  subjectFacets,
};

export default ApiContentSearch;
